import { useAuth } from '@fluentsms/auth';
import { useEffect } from 'react';
import { setApolloLink } from '../client';

export const useResetApolloLinkAfterLogin = () => {
  const { isAuthenticated } = useAuth();
  const _isAuthenticated = isAuthenticated();

  useEffect(() => {
    if (_isAuthenticated) {
      console.log('Resetting Apollo Link...');
      setApolloLink();
      console.log('Apollo Link Reset.');
    }
  }, [_isAuthenticated]);
};
